<template>
  <div class="text row smallwidth">
    <div class="col-60 acc" v-for="(z,index) in closedLines" :key="index">
      <div class="row acchead" @click.prevent="toggleLine(z, $event)">
        <div class="col-10 arrow"  :class="{'open':z.open}">
          <svg width="12" height="24" viewBox="0 0 12 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.5 0.5L11.5 12M0.5 23.5L11.5 12" stroke="#AD6766"/>
          </svg>

        </div>
        <div class="col-50 col-md-40">

          <div class="head" >
            <h4 v-html="z.header"></h4>
          </div>

        </div>
        <div class="d-none d-md-block col-md-10" style="text-align: right;">
          <div class="close" v-if="z.open" >

            <svg data-v-874003c2="" width="24" height="24" viewBox="0 0 24 24" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path data-v-874003c2="" d="M1 1L23 23M23 1L1 23" stroke="#ad6766"></path>
            </svg>
          </div>
        </div>
      </div>
      <div class="row" v-if="z.open">
        <div class="col-10">

        </div>
        <div class="col-50 col-md-40">
          <div class="acccontent" >

            <div v-html="z.text" class="text"></div>

            <img class="img" :src="z.bild.sizes['1536x1536']" alt="" v-if="z.bild && z.open">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Akkordeon",
  props: {b: Object},
  data() {
    return {
      closedLines: this.b.zeile.map(obj => ({...obj, 'open': false}))
    }

  },
  methods: {
    toggleLine(z, event) {
      if (!z.open && event) {
        window.scrollTo({
          top: event.pageY - 110,
          left: 0,
          behavior: 'smooth'
        });
      }
      z.open = !z.open;
    }
  },
  computed: {}
}
</script>
<style scoped lang="scss">
.acc {
  border-bottom: 1px solid #aaa;

  .acchead {
    padding-top: 20px;
    padding-bottom: 20px;

    cursor: pointer;
  }

  .head {
    //height: 24px;
  }

  .acccontent {
    padding: 0;
    margin-bottom: 20px;
  }

  .arrow {
    cursor: pointer;

    svg {

      transition: transform 0.2s ease;
    }

    &.open {
      svg {
        transform: rotate(90deg);
      }
    }
  }

  &:first-child {
    border-top: 1px solid #aaa;
  }
}

.img {
  max-width: 100%;
}


</style>